module.exports = __webpack_public_path__ + "img/confirm-b&w.db9a1f30.svg";